import { Vue } from 'vue-property-decorator';
import events from '@/events/Events';

type EventCallback = (data?: unknown) => void;

const eventBus = new Vue();

function subscribe(eventName: string, callback: EventCallback) {
  eventBus.$on(eventName, callback);
}

function unsubscribe(eventName: string, callback: EventCallback) {
  eventBus.$off(eventName, callback);
}

function broadcast(eventName: string, data?: unknown) {
  eventBus.$emit(eventName, data);
}

export {
  broadcast,
  subscribe,
  unsubscribe,
  events,
};
